import React, { useState, useEffect } from "react";
import { server, statusMessage } from "../../common";
import { useSelectAccess } from "../../store/stateFunctions";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import UserApplicationModal from "./UserApplicationModal";
import ReactHTMLTableToExcel from "react-html-table-to-excel";

const NagarrachanaTotalApplications = ({ role }) => {
  const [data, setData] = useState([]);
  const user = useSelectAccess(role);
  console.log("This is USer of this admin page ", role);
    console.log("This is USer of this admin pagecvbcgbdf ", user);

  const [showModal, setShowModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  // filters
  const [filters, setFilters] = useState({
    search: "",
    fromDate: "",
    toDate: "",
    permissionStatus: "",
    festivalName: "",
    divisionOffice: "",      // 🏢 नवीन
  policeDepartment: "", 
  });

  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);

  // Format datetime
  const formatDateTime = (dateTimeString) => {
    if (!dateTimeString) return "N/A";
    try {
      const date = new Date(dateTimeString);
      const formattedDate = date.toLocaleDateString("en-IN", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
      const formattedTime = date.toLocaleTimeString("en-IN", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
      return `${formattedDate} ${formattedTime}`;
    } catch {
      return dateTimeString;
    }
  };

  // status options
  const getStatusOptions = () => {
    const base = [
      { value: "", label: "All Status" },
      { value: "PENDING", label: "PENDING" },
      { value: "APPROVED", label: "APPROVED" },
      { value: "REJECTED", label: "REJECTED" },
    ];
    if (role === "Super Admin") base.push({ value: "CLOSED", label: "CLOSED" });
    return base;
  };

  console.log(role,"role here");
  
  // status badge class
  const getStatusBadgeClass = (item) => {
    const status = statusMessage(item, role);

    switch (status) {
      case "APPROVED":
        return "badge bg-success";
      case "REJECTED":
        return "badge bg-danger";
      case "PENDING":
        return "badge bg-warning text-dark";
      case "CLOSED":
        return "badge bg-secondary";
      default:
        return "badge bg-info";
    }
  };

  const handleShow = (id) => {
    setSelectedId(id);
    setShowModal(true);
  };
  const handleClose = () => setShowModal(false);

  // call data on page change
  useEffect(() => {
    getData(currentPage);
  }, [currentPage]);

  // handle filter change
  const handleFilterChange = (name, value) => {
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const applyFilters = () => {
    setCurrentPage(1);
    getFilteredData(1);
  };

  const clearFilters = () => {
    setFilters({
      search: "",
      fromDate: "",
      toDate: "",
      permissionStatus: "",
      festivalName: "",
      divisionOffice: "",      // ✅ हे reset केले
    policeDepartment: "",    // ✅ हे पण reset केले
    });
    setCurrentPage(1);
    getData(1);
  };

  // filtered API call
  // filtered API call
  const getFilteredData = (page) => {
    const queryParams = new URLSearchParams({
      page: page.toString(),
      role: role,
      // 👉 filter apply zala ki limit nko
      ...Object.fromEntries(
        Object.entries(filters).filter(([_, v]) => v !== "")
      ),
    });

    server
      .get(`/user_appl/getfilteredappl?${queryParams.toString()}`, {
        headers: { Authorization: user.authToken },
      })
      .then((res) => {
        if (res.status === 200) {
          setData(res.data.results);

          // 👉 filter laun data lavkar disava mhanun pagination disable kar
          setTotalPages(1);
        }
      })
      .catch((err) =>
        toast.error(err.response?.data?.message || "Server Error")
      );
  };

  // default all data
  const getData = (page) => {
    server
      .get(`/user_appl/getallappl?page=${page}&limit=10`, {
        headers: { Authorization: user.authToken },
      })
      .then((res) => {
        if (res.status === 200) {
          setData(res.data.results);
          setTotalPages(res.data.totalPages);
        }
      })
      .catch((err) =>
        toast.error(err.response?.data?.message || "Server Error")
      );
  };

  // 🔎 Quick Search logic reused in advanced search
  const SearchData = (value) => {
    setFilters((prev) => ({ ...prev, search: value }));
    if (value.trim() === "") {
      getData(currentPage);
      return;
    }
    server
      .get(`/user_appl/searchmandalbyid?search=${value}`, {
        headers: { Authorization: user.authToken },
      })
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
          setTotalPages(1);
        }
      })
      .catch((err) =>
        toast.error(err.response?.data?.message || "Server Error")
      );
  };

  return (
    <div className="container mt-4">
      

      {/* Advanced Filters */}
      <div className="card mb-3">
        <div className="card-header">
          <h5 className="mb-0">Quick Search Application</h5>
        </div>
        <div className="card-body">
          <div className="row">
            {/* Search */}
            <div className="col-md-3 mb-3">
              <label>अँप्लिकेशन नंबर/नाव/उत्सव :</label>
              <input
                type="text"
                className="form-control"
                placeholder="Name, Application No, Festival"
                value={filters.search}
                onChange={(e) => handleFilterChange("search", e.target.value)}
              />
            </div>
            {/* From Date */}
            <div className="col-md-3 mb-3">
              <label>From Date:</label>
              <input
                type="date"
                className="form-control"
                value={filters.fromDate}
                onChange={(e) => handleFilterChange("fromDate", e.target.value)}
              />
            </div>
            {/* To Date */}
            <div className="col-md-3 mb-3">
              <label>To Date:</label>
              <input
                type="date"
                className="form-control"
                value={filters.toDate}
                onChange={(e) => handleFilterChange("toDate", e.target.value)}
              />
            </div>
            {/* Status */}
            <div className="col-md-3 mb-3">
              <label>Status:</label>
              <select
                className="form-control"
                value={filters.permissionStatus}
                onChange={(e) =>
                  handleFilterChange("permissionStatus", e.target.value)
                }
              >
                {getStatusOptions().map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </div>
            {/* Festival */}
            <div className="col-md-3 mb-3">
              <label>Festival Name:</label>
              <select
                className="form-control"
                value={filters.festivalName}
                onChange={(e) =>
                  handleFilterChange("festivalName", e.target.value)
                }
              >
                <option value="">All Festivals</option>
                <option value="ganesh_utsav">Ganesh Utsav</option>
                <option value="navratri">Navratri</option>
                <option value="shiv_jayanti">Shiv Jayanti</option>
                <option value="ambedkar_jayanti">Ambedkar Jayanti</option>
                <option value="other">Other</option>
              </select>
            </div>
        {role !== "Division Officer" && (
  <div className="col-md-3 mb-3">
    <label>विभागीय कार्यालय (Division Office):</label>
    <select
      className="form-control"
      value={filters.divisionOffice}
      onChange={(e) => handleFilterChange("divisionOffice", e.target.value)}
    >
      <option value="">सर्व विभाग</option>
      <option value="सावेडी">सावेडी</option>
      <option value="वसुली">वसुली</option>
      <option value="झेंडीगेट">झेंडीगेट</option>
      <option value="बुरुडगांव">बुरुडगांव</option>
    </select>
  </div>
)}
{/* Police Department */}
<div className="col-md-3 mb-3">
  <label>पोलीस स्टेशन:</label>
  <select
    className="form-control"
    value={filters.policeDepartment}
    onChange={(e) => handleFilterChange("policeDepartment", e.target.value)}
  >
    <option value="">सर्व पोलीस स्टेशन</option>
    <option value="तोफखाना पोलिस स्टेशन">तोफखाना पोलिस स्टेशन</option>
    <option value="कोतवाली पोलिस स्टेशन">कोतवाली पोलिस स्टेशन</option>
    <option value="एम. आय. डी.सी. पोलिस स्टेशन">MIDC पोलिस स्टेशन</option>
    <option value="भिंगार कॅम्प पोलिस स्टेशन">भिंगार कॅम्प पोलिस स्टेशन</option>
  </select>
</div>
          </div>
          <div>
            <button className="btn btn-primary me-2" onClick={applyFilters}>
              <i className="fas fa-search me-2"></i> Apply Filters
            </button>
            <button className="btn btn-secondary" onClick={clearFilters}>
              <i className="fas fa-times me-2"></i> Clear Filters
            </button>
          </div>
        </div>
      </div>

      {/* Export */}
      <div className="text-end mb-3">
        <ReactHTMLTableToExcel
          className="btn btn-success"
          table="totalapplications"
          filename={`Total Applications Report ${
            new Date().toISOString().split("T")[0]
          }`}
          sheet="Applications Report"
          buttonText="📊 Export To Excel"
        />
      </div>

      {/* Table */}
      <div className="card" >
        <div className="card-header d-flex justify-content-between">
          <span>Total Applications</span>
          <span className="badge bg-primary">{data.length} Records</span>
        </div>
        <div className="card-body table-responsive">
          <table
            className="table table-striped table-bordered text-center"
            id="totalapplications"
          >
            <thead className="table-dark">
              <tr>
                <th>Sr.No</th>
                <th>Application No.</th>
                <th>Date/Time</th>
                <th>Festival</th>
                <th>Prabhag</th>
                  <th>Police Department</th>
                <th>Applicant</th>
                <th>Address</th>
                <th>Contact</th>
                <th>Mandal</th>
                <th>Mandal Address</th>
                <th>Status</th>
                {role !== "Super Admin" && <th>Action</th>}
              </tr>
            </thead>
            <tbody>
              {data.length ? (
                data.map((item, i) => (
                  <tr key={item.id}>
                    <td>{(currentPage - 1) * 10 + i + 1}</td>
                    <td>
                      <b>{item.id}</b>
                    </td>
                    <td>{formatDateTime(item.created_at)}</td>
                    <td>
                      <span className="badge bg-info">
                        {item.festival_name?.replace("_", " ").toUpperCase()}
                      </span>
                    </td>
                    <td>{item.department_divisional_office}</td>
                                        <td>{item.police_department}</td>

                    <td>{item.name}</td>
                    <td className="text-start">{item.address}</td>
                    <td>{item.mobile}</td>
                    <td>{item.mandal_name}</td>
                    <td className="text-start">{item.mandal_address}</td>
                    <td>
                      <span className={getStatusBadgeClass(item)}>
                        {statusMessage(item, role)}
                      </span>
                    </td>
                    {role !== "Super Admin" && (
                      <td>
                        <button
                          className="btn btn-primary btn-sm"
                          onClick={() => handleShow(item.id)}
                        >
                          <i className="fas fa-eye me-1"></i> View
                        </button>
                      </td>
                    )}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={role !== "Super Admin" ? "12" : "11"}>
                    <div className="text-muted py-4">
                      <i className="fas fa-inbox fa-2x"></i>
                      <p>No applications found</p>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Pagination */}
      {totalPages > 1 && (
  <nav className="mt-3">
    <ul className="pagination justify-content-center flex-wrap">
      {/* Prev button */}
      <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
        <button
          className="page-link"
          onClick={() => setCurrentPage((p) => p - 1)}
        >
          Prev
        </button>
      </li>

      {/* Dynamic page numbers */}
      {Array.from({ length: totalPages }, (_, i) => i + 1)
        .filter(
          (page) =>
            page === 1 || // पहिला
            page === totalPages || // शेवटचा
            (page >= currentPage - 2 && page <= currentPage + 2) // current जवळचे
        )
        .map((page, idx, arr) => {
          const prev = arr[idx - 1];
          const showDots = prev && page - prev > 1;
          return (
            <React.Fragment key={page}>
              {showDots && (
                <li className="page-item disabled">
                  <span className="page-link">...</span>
                </li>
              )}
              <li
                className={`page-item ${currentPage === page ? "active" : ""}`}
              >
                <button className="page-link" onClick={() => setCurrentPage(page)}>
                  {page}
                </button>
              </li>
            </React.Fragment>
          );
        })}

      {/* Next button */}
      <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
        <button
          className="page-link"
          onClick={() => setCurrentPage((p) => p + 1)}
        >
          Next
        </button>
      </li>
    </ul>
  </nav>
)}


      <UserApplicationModal
        show={showModal}
        handleClose={handleClose}
        id={selectedId}
        role={role}
      />
    </div>
  );
};

export default NagarrachanaTotalApplications;
